import { Tooltip } from "@mui/material";

const ParamValueCellRenderer = (params: { value: string | number }) => {
  return (
    <div className="ag-center">
     <Tooltip
  title={params.value}
  arrow
  slotProps={{
    tooltip: {
      sx: {
        backgroundColor: "#fff", 
        color: "#000",           
        boxShadow: 1,
        fontSize: "0.775rem",
      },
    },
    arrow: {
      sx: {
        color: "#fff", 
      },
    },
  }}
>
  <span>{params.value}</span>
</Tooltip>


    </div>
  );
};

export default ParamValueCellRenderer;
